
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#308BE5","d":"M42.51 56.13a6 6 0 01-5.91 0L17.38 45.24a5.3 5.3 0 10-5.23 9.24L36.6 68.33a6 6 0 005.91 0l24.45-13.85a5.3 5.3 0 10-5.23-9.24L42.5 56.13z"}}),_c('path',{attrs:{"fill":"#A8D1FA","d":"M42.52 46.3a6 6 0 01-5.93 0L17.4 35.4a5.3 5.3 0 10-5.24 9.23L36.6 58.46a6 6 0 005.91 0l24.45-13.84a5.3 5.3 0 10-5.23-9.23L42.52 46.3z"}}),_c('path',{attrs:{"fill":"#308BE5","d":"M42.51 11.67a6 6 0 00-5.91 0L13.22 24.92a6 6 0 000 10.44l1.55.88 21.82 12.4a6 6 0 005.93 0l21.82-12.4 1.55-.88a6 6 0 000-10.44L42.51 11.67z"}})])
          )
        }
      }
    